<template>
  <!--企业类型-->
  <el-select v-model="enterpriseTypeCode" clearable>
    <el-option
      v-for="item in enterpriseTypeList"
      :key="item.dictCode"
      :label="item.dictName"
      :value="item.dictCode">
    </el-option>
  </el-select>
  <!------------>
</template>

<script>
  import {getListByTypeCodeAndPCode} from '@/api/dict/dic_manage'

  export default {
    name: "select-enterpriseType",
    data() {
      return {
        enterpriseTypeList: [],
        enterpriseTypeCode: ''
      }
    },
    created() {
      let data = {
        dictTypeCode: 'ENTERPRISE_TYPE',
        parentCode: -1,
      }
      getListByTypeCodeAndPCode(data).then(res => {
        if (res.code == 1) {
          this.enterpriseTypeList = res.data
        }
      })
    },
    watch: {
      enterpriseTypeCode: function (currentVal) {
        this.$emit('enterpriseTypeInfo', {enterpriseTypeCode: currentVal})
      }
    }
  }
</script>

<style scoped>

</style>
